export const DEFAULT_NODE_WIDTH = 460;
